function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2803 8.47225C31.0143 3.56417 39.991 0.971458 49.1508 1.00024C58.3106 1.02902 67.271 3.67808 74.9739 8.63467L57.5714 35.6794C55.0294 34.0438 52.0725 33.1696 49.0498 33.1601C46.0271 33.1506 43.0647 34.0062 40.5125 35.6258L23.2803 8.47225Z",
  fill: "#FBBF24",
  stroke: "black",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.7904 8.51721C81.6093 12.8613 87.2204 18.8575 91.103 25.9493C94.9857 33.0411 97.0141 40.9987 97 49.0838L64.84 49.0277C64.8446 46.3596 64.1753 43.7336 62.894 41.3933C61.6127 39.053 59.7611 37.0742 57.5108 35.6407L74.7904 8.51721Z",
  fill: "#16A34A",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 49C1 40.9149 3.04226 32.9608 6.93728 25.8758C10.8323 18.7908 16.4539 12.8045 23.2803 8.47226L40.5085 35.6196C38.2548 37.0499 36.3988 39.0263 35.1128 41.3655C33.8269 43.7046 33.1526 46.3307 33.1526 49L1 49Z",
  fill: "#DC2626",
  stroke: "black",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M57 49C57 53.4183 53.4183 57 49 57C44.5817 57 41 53.4183 41 49C41 44.5817 44.5817 41 49 41C53.4183 41 57 44.5817 57 49Z",
  fill: "#181818"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6413 33.2889C75.4737 33.0005 76.0928 34.0728 75.4269 34.6495L51.5886 55.2941C51.2088 55.623 50.6233 55.5245 50.3721 55.0893L44.4125 44.7671C44.1613 44.3319 44.3687 43.7756 44.8435 43.6111L74.6413 33.2889Z",
  fill: "#181818"
});

function SvgSpeedoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 57,
    viewBox: "0 0 98 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedoGreen);
export default __webpack_public_path__ + "static/media/SpeedoGreen.7fd6fb43.svg";
export { ForwardRef as ReactComponent };